import { useState } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import BrochureForm from "../components/brochure-form";
import PageHeader from "./PageHeader";
import "./ChairmanMessage.css";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

const ceoMessageParagraphs = [
  "Today, education plays a vital role in the growth and development of the nation. It has always been at the centre from the time immemorial. In the historic period, it had a job of cultivating and nurturing values in young minds. In the modern period the dimension and scope of education has been changed with the outbreak of industrialization and modernization, giving birth to different disciplines in education including Technical education. Technical education has the power and potential to develop the nation in all regards in many fields. A major transformation came during the information age when India established its position with its strong core competence in information technology.",
  "Though India is a developing nation, there are many challenges left in the nation such as poverty, unemployment, development of infrastructure at grass root level and many more. To transform India from a developing nation to a developed nation, we need to concentrate on ICT sector which may majority contribute to India’s GDP growth.",
  "Understanding the gravity of the situation, we, at TIMSCDR, are committed to provide the quality technical education and to create socially responsible leaders. To serve this purpose TIMSCDR is well equipped with state-of-the-art infrastructure and a team of motivated, experienced and committed faculty led by visionary, devoted and dedicated Director.",
  "“Perfection is a process and we are on our way…”"
];

function Ceo() {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="chairman-page ceo">
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <PageHeader
        title="CEO's Message"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "CEO's Message" },
        ]}
      />

      <main className="chairman-message-wrap">
        <section className="chairman-message-card" aria-labelledby="ceo-message-title">
          <aside className="chairman-profile">
            <img src="/images/Karishma-CEO.jpg" alt="Ms. Karishma Singh" />
            <div className="chairman-profile-caption">
              <h2 id="ceo-message-title">Ms. Karishma Singh</h2>
              <p>CEO</p>
              <span aria-hidden="true" />
            </div>
          </aside>

          <article className="chairman-copy">
            <span className="chairman-quote-mark" aria-hidden="true">
              &ldquo;
            </span>
            {ceoMessageParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            <div className="chairman-signature">
              <strong>Ms. Karishma Singh</strong>
              <span>CEO, TIMSCDR</span>
            </div>
          </article>
        </section>
      </main>

      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </div>
  );
}

export default Ceo;